
// @ts-nocheck





import { i18nText } from '@/locales';


import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {mixins} from "vue-class-component";
import {VisitsMix} from "@/UI/mixins/Clients/VisitsMix";
import {NotesTableMix} from "@/UI/mixins/Clients/NotesTableMix";
import {SalonsMix} from "@/UI/mixins/SalonsMix";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue";
import {WorkersMix} from "@/UI/mixins/Store/WorkersMix";
import {FiltersData} from "@/entity/filters/extFilter";
import {SettingsUserMix} from "@/UI/mixins/Users/SettingsUserMix";
import {ClientsMix} from "@/UI/mixins/ClientsMix";
import {prefixObj} from "@/UI/lib/support";
import {getStudioId} from "@/UI/lib/state";
import {ProxyGetData} from "../Helpers/getData";
import {checkUserRole} from "@/router/Lib/helper";
import {ScrollData} from "@/UI/Decorators/decorator";
import {WorkersStore} from "@/store/modules/Workers";
import {SalonsStore} from "@/store/modules/Salons";
import {UserStore} from "@/store/modules/User";

@Component({
  components: {
    PageTitle,
    FilterTableComponent
  },
  methods: {
    prefixObj
  },
  computed: {
    checkUserRole
  },
})

export default class ClientNotes extends mixins(
    ProxyGetData,
    VisitsMix,
    NotesTableMix,
    SalonsMix,
    WorkersMix,
    SettingsUserMix,
    ClientsMix,
) {
  filtersData = new FiltersData();
  eternal_workers: any = []
  eternal_users: any = []
  eternal_studios: any = []

  @ScrollData
  HScroll(source: any, filter: any): void {
  }

  handleScroll(source: any, filter: any): void {
    this.HScroll(source, filter)
  }

  sort(by: string, column: any): void {
    if (column.dataIndex === 'salon.name') {
      column.dataIndex = 'salon_id'
    }
    if (column.dataIndex === 'status') {
      column.dataIndex = 'status_id'
    }
    this.sortedData(by, column)
  }

  async created(): Promise<void> {
    try {
      this.proxyFilter = {
        salon_id: getStudioId(this),
        client_id: Vue.router.currentRoute.params['id']
      }
      await this.getData()
      let modules: any = [
        {s: 'workers', p: {limit: -1, filter: {salon_id: getStudioId(this)}}},
        {s: 'user', p: {limit: -1, filter: {salon_id: getStudioId(this)}}}
      ]
      if (checkUserRole() !== 'owner') {
        modules.push({s: 'salons', p: {limit: this.AppPageParams.pageSize}})
      }
      await this.fetchModules(modules)
      this.setFilters(this)
      this.eternal_workers = WorkersStore.workers?.data
      this.eternal_users = UserStore.users.data
      this.eternal_studios = SalonsStore.salons?.data

    } catch (e) {
      console.error(e)
    }
  }

  setFilters(that: any): void {
    if (checkUserRole() !== 'owner') {
      this.filtersData.filters.push({
        key: 0,
        type: "sourceVuex",
        label: i18nText("Студии"),
        vuexSource: 'salons',
        storeVuexSource: 'salons',
        default_value: [i18nText("Не указано")],
        async onChange(value: any) {

          await that.filterData({
            salon_id: value
          })
        },
        async onSearch(value: any) {
          await that.fetchModules([
            {s: 'salons', p: {filter: {name: value}}}
          ])
        },
        async onFocus() {
// @ts-ignore
          SalonsStore.salons?.data = that.eternal_studios
        },
        async onScroll() {
          await that.handleScroll('salons')
        }
      });
    }

    this.filtersData.filters.push(
        {
          key: 1,
          type: "sourceVuex",
          label: i18nText("Косметолог"),
          default_value: [i18nText("Не указано")],
          vuexSource: "workers",
          storeVuexSource: "workers",
          async onSearch(value: any) {
            await that.fetchModules([{
              s: 'workers',
              p: {
                filter: {
                  name: value,
                  salon_id: Vue.router.currentRoute.params.salon_id
                }
              }
            }])
          },
          async onChange(value: any) {
            await that.filterData({
              cosmetologists_id: value
            })
          },
          async onScroll() {
          },
          async onFocus() {
// @ts-ignore
            WorkersStore.workers?.data = that.eternal_workers
          }
        },
        {
          key: 2,
          type: "sourceVuex",
          label: i18nText("Создал"),
          default_value: [i18nText("Не указано")],
          vuexSource: "users",
          storeVuexSource: "user",
          async onSearch(value: any) {
            await that.fetchModules([{
              s: 'user',
              p: {
                filter: {
                  name: value,
                  salon_id: Vue.router.currentRoute.params.salon_id
                }
              }
            }])
          },
          async onChange(value: any) {
            await that.filterData({
              user_id: value
            })
          },
          async onScroll() {
          },
          async onFocus() {
            UserStore.users.data = that.eternal_users
          }
        },
        {
          key: 3,
          type: "select",
          label: i18nText("Статус"),
          default_value: [i18nText("Не указано")],
          value: [
            {
              label: i18nText("Не указано"),
              key: "0",
            },
            {
              label: i18nText("Ожидание клиента"),
              key: "1",
            },
            {
              label: i18nText("Клиент пришел"),
              key: "2",
            },
            {
              label: i18nText("Клиент не пришел"),
              key: "3",
            },
            {
              label: i18nText("Клиент подтвердил"),
              key: "4",
            },
          ],
          async onChange(value: any) {
            await that.filterData({
              status_id: value
            })
          },
          async onSearch() {
          },
          async onFocus() {
          },
          async onScroll() {
          }
        },
        {
          key: 4,
          type: "datetimerange",
          label: i18nText("Дата визита"),
          placeholder: "",
          async onChange(value: any) {
            let filter = {}
            if (value.length === 0) {
              filter = {
                visit_dt_from: '0',
                visit_dt_to: '0'
              }
            } else {
              filter = {
                visit_dt_from: value[0].format("DD.MM.YYYY"),
                visit_dt_to: value[1].format("DD.MM.YYYY")
              }
            }
            await that.filterData(filter)
          },
        }
    )
    this.filter_load = true
  }
}
